import { apiBaseUrl } from "./config";
import { sendPost } from "./utils";

const baseUrl = `${apiBaseUrl}/users`;

async function userRegister(body) {
  const url = `${baseUrl}/register`;

  try {
    const r = await fetch(url,
      {
        method: 'PUT',
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await r.json();
    console.log(data);

    if (!r.ok) {
      throw data
    }
    
    return data;
  }
  catch(e) {
    console.log(e);
    throw e;
  }
}

async function userLogin(email, password) {
  const url = `${baseUrl}/login`;
  const body = {
    email: email,
    password: password
  }
  try {
    const r = await fetch(url,
      {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await r.json();
    console.log(data);

    if (!r.ok) {
      throw data
    }
    
    return data;
  }
  catch(e) {
    console.log(e);
    throw e;
  }
}

async function getALlowedSections(token) {
  const url = `${baseUrl}/sections`;
  const r = await fetch(url, {headers: { Authorization: `Bearer ${token}`}});
  const data = await r.json();
  return data;
}

async function searchUser(token, q) {
  const url = `${baseUrl}/search?q=${q}`;
  const r = await fetch(url, {headers: { Authorization: `Bearer ${token}`}});
  const data = await r.json();
  return data;
}

async function getMembers(token, params ) {
  let url = `${baseUrl}/members`;
  const urlParams = getMemberParams(params);
  url += urlParams;

  const r = await fetch(url, {headers: { Authorization: `Bearer ${token}`}});
  if (r.ok) {
    const data = await r.json();
    return data;  
  }
  else {
    throw {
      status: r.status
    }
  }
  
}

async function downloadMembers(token, params ) {
  let url = `${baseUrl}/members/download`;
  const urlParams = getMemberParams(params);
  url += urlParams;

  const r = await fetch(url, {headers: { Authorization: `Bearer ${token}`}});
  if (r.ok) {
    const file = await r.text();
    const universalBOM = "\uFEFF";
    const a = document.createElement('a');
    a.href = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + file);
    a.download = 'fama-miembros.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  else {
    throw {
      status: r.status
    }
  } 
}

function getMemberParams(params) {
  let addedParams = 0;
  let urlParams = '';
  Object.keys(params).forEach(key => {
    if (params[key]) {
      if (!addedParams) {
        urlParams += '?';
      }
      if (addedParams > 0) {
        urlParams += '&';
      }
      urlParams += `${key}=${params[key]}`;
      addedParams++;
    }
  });
  return urlParams;
}

async function getUser(token, userId) {
  let url = baseUrl;
  if (userId) {
    url += `/${userId}`;
  }
  const r = await fetch(url, {headers: { Authorization: `Bearer ${token}`}});
  if (r.ok) {
    const data = await r.json();
    return data;  
  }
  else {
    throw {
      status: r.status
    }
  }
}

async function updateProfile(token, userId, profile) {
  let url = `${baseUrl}/${userId}/profile`;
  let r = await sendPost(token, url, profile);
  return r;
}

async function updateAddress(token, userId, address) {
  let url = `${baseUrl}/${userId}/address`;
  let r = await sendPost(token, url, address);
  return r;
}

async function updateAccount(token, userId, email, password) {
  let url = `${baseUrl}/${userId}`;
  let r = await sendPost(token, url, { email, password });
  return r;
}

async function updateMembership(token, userId, membership) {
  let url = `${baseUrl}/${userId}/membership`;
  let r = await sendPost(token, url, membership);
  return r;
}

async function updateConsents(token, userId) {
  let url = `${baseUrl}/${userId}/consents`;
  let r = await sendPost(token, url);
  return r;
}

async function forgotPassword(email) {
  let url = `${baseUrl}/forgotpassword`;
  let r = await sendPost(null, url, {email: email});
  return r;
}

async function resetPassword(resetPasswordToken, newPassword) {
  let url = `${baseUrl}/resetpassword`;
  let r = await sendPost(null, url, { resetPasswordToken, password: newPassword});
  return r;
}

export {
  userRegister,
  userLogin,
  getALlowedSections,
  searchUser,
  getMembers,
  downloadMembers,
  getUser,
  updateProfile,
  updateAddress,
  updateAccount,
  updateMembership,
  updateConsents,
  forgotPassword,
  resetPassword
};
